import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5080Class } from '../../CSPClass/CSP5080/csp5080-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5080Service {
    baseUrl: string=  environment.baseUrlCsp + 'CSP5080/';
  constructor(private http:HttpClient) { }

    Hostel(Csp5080Class:Csp5080Class):Observable<any>
                {                 
                   return this.http.post<any>(this.baseUrl+'Hostel',Csp5080Class);
               }
  
}
